import api from './api';

export interface CheckoutRequest {
  email: string;
  billingType: 'PIX' | 'CREDIT_CARD' | 'BOLETO';
  name?: string;
  cpfCnpj?: string;
  phone?: string;
}

export interface CheckoutResponse {
  subscriptionId: string;
  paymentUrl?: string;
  pixQrCode?: string;
  pixCopyPaste?: string;
}

export interface SubscriptionStatus {
  isPremium: boolean;
  subscriptionId: string | null;
  expiresAt: string | null;
  trialUsed: boolean;
}

export interface SubscriptionPlan {
  monthlyPrice: number;
  currency: string;
  trialDays: number;
  formattedPrice: string;
}

const checkoutService = {
  /**
   * Cria checkout para assinatura
   * Endpoint público - busca usuário por email
   */
  async createCheckout(data: CheckoutRequest): Promise<CheckoutResponse> {
    const response = await api.post<CheckoutResponse>(
      '/subscriptions/checkout-public',
      data,
    );
    return response.data;
  },

  /**
   * Verifica status da assinatura
   * Requer autenticação
   */
  async getStatus(): Promise<SubscriptionStatus> {
    const response = await api.get<SubscriptionStatus>('/subscriptions/status');
    return response.data;
  },

  /**
   * Cancela assinatura
   * Requer autenticação
   */
  async cancelSubscription(): Promise<void> {
    await api.post('/subscriptions/cancel');
  },

  /**
   * Busca os dados públicos do plano (preço, trial)
   */
  async getPlan(): Promise<SubscriptionPlan> {
    const response = await api.get<SubscriptionPlan>('/subscriptions/plan');
    return response.data;
  },

  /**
   * Busca informações do usuário pelo email (para pré-preencher checkout)
   */
  async getUserInfo(email: string): Promise<{ found: boolean; name?: string }> {
    try {
      const response = await api.get(`/subscriptions/user-info?email=${encodeURIComponent(email)}`);
      return response.data;
    } catch {
      return { found: false };
    }
  },
};

export default checkoutService;
